import React from 'react';

const Errorpage = () => {
    return (
        <div className="mx-auto border border-primary mr-4">
            <h1>Error : 404</h1>
            <p>Data not match</p>
        </div>
    );
};

export default Errorpage;